export default __webpack_public_path__ + "static/media/ods14.8c7e6c4d.svg";